import React from "react";

import MyTrips from "../MyTrips";
import ProfileAvatarPositionModal from "../ProfileAvatarPositionModal";
import ProfileCoverPositionModal from "../ProfileCoverPositionModal";

export default function ProfileActionPanels({ profile }) {
  const {
    t,
    isOwnProfile,
    favoriteSpots,
    showFavorites,
    showTrips,
    showCatches,
    fullscreenMedia,
    showMediaMenu,
    showAvatarPositionModal,
    avatarPositionFile,
    showCoverPositionModal,
    coverPositionFile,
    pendingDeletePostId,
    deletingPostId,
    savingMediaMode,
    coverFrameAspectRatio,
    handleCloseFavorites,
    handleFavoriteSpotOpen,
    handleCloseTrips,
    handleCloseCatches,
    handleCloseFullscreenMedia,
    handleFullscreenCameraClick,
    handleCloseMediaMenu,
    handleMediaMenuAddPhoto,
    handleCancelDeletePost,
    handleConfirmDeletePost,
    handleAvatarPositionCancel,
    handleAvatarPositionConfirm,
    handleCoverPositionCancel,
    handleCoverPositionConfirm,
    user,
  } = profile;

  return (
    <>
      {showFavorites && (
        <div className="profile-popup">
          <h3>{'\u2764'} {t("favorite_spots")}</h3>

          {favoriteSpots.length === 0 ? (
            <p>{t("no_favorite_spots")}</p>
          ) : (
            <ul>
              {favoriteSpots.map((spot, index) => (
                <li key={index}>
                  <strong>{spot.name}</strong>
                  <div>{spot.location}</div>
                  <div>
                    {spot.lat?.toFixed(3)}, {spot.lng?.toFixed(3)}
                  </div>

                  <button
                    className="open-location-btn"
                    onClick={() => handleFavoriteSpotOpen(spot)}
                  >
                    {'\u{1F4CD}'} {t("open_location")}
                  </button>
                </li>
              ))}
            </ul>
          )}

          <button className="close-popup-btn" onClick={handleCloseFavorites}>
            {t("close")}
          </button>
        </div>
      )}

      {showTrips && <MyTrips setShowTrips={handleCloseTrips} user={user} />}

      {showCatches && (
        <div className="profile-popup">
          <h3>{'\u{1F3A3}'} {t("my_catches")}</h3>
          <p>{t("catches_placeholder")}</p>
          <button className="close-popup-btn" onClick={handleCloseCatches}>
            {t("close")}
          </button>
        </div>
      )}

      {fullscreenMedia && (
        <div
          className="profile-media-overlay"
          onClick={handleCloseFullscreenMedia}
        >
          <button
            className="profile-media-close"
            onClick={(event) => {
              event.stopPropagation();
              handleCloseFullscreenMedia();
            }}
          >
            {'\u2715'}
          </button>

          {fullscreenMedia.src && (
            <img
              src={fullscreenMedia.src}
              alt=""
              className="profile-media-expanded"
              onClick={(event) => event.stopPropagation()}
            />
          )}

          {isOwnProfile && (
            <button
              className="profile-media-camera"
              aria-label={
                fullscreenMedia?.type === "avatar"
                  ? t("profile_change_photo_label", {
                      defaultValue: "Change profile photo",
                    })
                  : t("profile_change_cover_label", {
                      defaultValue: "Change cover photo",
                    })
              }
              onClick={handleFullscreenCameraClick}
            >
              {'\u{1F4F7}'}
            </button>
          )}

          {showMediaMenu && isOwnProfile && (
            <div
              className="profile-media-menu"
              onClick={(event) => event.stopPropagation()}
            >
              <button onClick={handleMediaMenuAddPhoto}>{t("add_photo")}</button>

              <button onClick={handleCloseMediaMenu}>{t("cancel")}</button>
            </div>
          )}
        </div>
      )}

      {pendingDeletePostId && (
        <div
          className="profile-delete-confirm-overlay"
          onClick={handleCancelDeletePost}
        >
          <div
            className="profile-delete-confirm-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="profile-delete-media-title"
            onClick={(event) => event.stopPropagation()}
          >
            <h3
              className="profile-delete-confirm-title"
              id="profile-delete-media-title"
            >
              {t("profile_delete_media_title", {
                defaultValue: "Delete selected media?",
              })}
            </h3>
            <p className="profile-delete-confirm-text">
              {t("profile_delete_media_body", {
                defaultValue: "This action cannot be undone.",
              })}
            </p>
            <div className="profile-delete-confirm-actions">
              <button
                type="button"
                className="profile-delete-confirm-cancel"
                onClick={handleCancelDeletePost}
                disabled={deletingPostId === pendingDeletePostId}
              >
                {t("common_cancel", { defaultValue: "Cancel" })}
              </button>
              <button
                type="button"
                className="profile-delete-confirm-delete"
                onClick={handleConfirmDeletePost}
                disabled={deletingPostId === pendingDeletePostId}
              >
                {t("profile_delete_media_confirm", {
                  defaultValue: "Delete",
                })}
              </button>
            </div>
          </div>
        </div>
      )}

      <ProfileAvatarPositionModal
        open={showAvatarPositionModal}
        file={avatarPositionFile}
        isSaving={savingMediaMode === "avatar"}
        onCancel={handleAvatarPositionCancel}
        onConfirm={handleAvatarPositionConfirm}
      />

      <ProfileCoverPositionModal
        open={showCoverPositionModal}
        file={coverPositionFile}
        frameAspectRatio={coverFrameAspectRatio}
        isSaving={savingMediaMode === "cover"}
        onCancel={handleCoverPositionCancel}
        onConfirm={handleCoverPositionConfirm}
      />
    </>
  );
}
